import React, { useState } from "react";
import call_icon from "../../assets/icons/call_icon.png";
import white_calender_icon from "../../assets/icons/white_calender_icon.png";
import avatar from "../../assets/images/avatar.png";
import { Link } from "react-router-dom";
import EditTaskModal from "../../components/modals/EditTaskModal";
import EmailTaskSuccessModal from "../../components/modals/EmailTaskSuccessModal";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import TasksPage from "../TasksPage";
import TaskFilter from "../../components/TaskFilter";
import bi_filter_yellow from "../../assets/icons/bi_filter_yellow.png";

const TodayTasks = () => {
  const [activeTab, setActiveTab] = useState("follow");
  const [editTask, setEditTask] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const closeModal = () => {
    setEditTask(false);
  };

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const [tasksFilter, setTasksFilter] = useState(false);

  const toggleTasksFilter = () => {
    setTasksFilter(!tasksFilter);
  };
  return (
    <>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Exhibition Master" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="flex">
        <div className={`${tasksFilter ? "w-[80%]" : "w-[95%]"} `}>
          <TasksPage />
          {/* Four sections below Tasks Routes */}
          <div className="ml-4 mt-9">
            <div className="flex w-[95%] justify-between overflow-auto">
              <div
                className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
                  activeTab === "follow" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
                }`}
                onClick={() => setActiveTab("follow")}
              >
                <p className="font-bold text-[24px]">02</p>
                <p className="text-[16px] text-[#91929E]">Follow Ups</p>
              </div>
              <div
                className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
                  activeTab === "pending" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
                }`}
                onClick={() => setActiveTab("pending")}
              >
                <p className="font-bold text-[24px]">04</p>
                <p className="text-[16px] text-[#91929E]">Pending Visits</p>
              </div>
              <div
                className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
                  activeTab === "docs" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
                }`}
                onClick={() => setActiveTab("docs")}
              >
                <p className="font-bold text-[24px]">03</p>
                <p className="text-[16px] text-[#91929E]">Send Docs</p>
              </div>
              <div
                className={`flex flex-col items-center  px-16 py-4 rounded-lg cursor-pointer ${
                  activeTab === "sample" ? "bg-[#E5F8FF]" : "bg-[#FAFAFA]"
                }`}
                onClick={() => setActiveTab("sample")}
              >
                <p className="font-bold text-[24px]">03</p>
                <p className="text-[16px] text-[#91929E]">sample Text</p>
              </div>
            </div>

            {/* First Box */}
            <div
              className="border rounded-lg p-4 mt-8 cursor-pointer w-[95%]"
              onClick={() => setEditTask(true)}
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-[18px] font-bold">
                    Follow up mode: Calling
                  </p>
                  <p className="text-[14px] text-[#828282] mt-4">
                    Praveen Sharma : Shopper Stop
                  </p>
                </div>
                <div>
                  <img src={call_icon} alt="call" />
                </div>
              </div>
              <hr />
              <div className="flex justify-between items-center pt-4">
                <div className="flex items-center ">
                  <div>
                    <img src={white_calender_icon} alt="calender" />
                  </div>
                  <p className="text-[14px] text-[#7B7B7B] ml-1">
                    Mon, 10 July 2022
                  </p>
                </div>
                <Link to="/tasks/customer-history" className="w-6 mr-2">
                  <img src={avatar} className="rounded-full" alt="avatar" />
                </Link>
              </div>
            </div>

            {/* Second Box */}
            <div
              className="border rounded-lg p-4 mt-8 cursor-pointer w-[95%]"
              onClick={() => setEditTask(true)}
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-[18px] font-bold">
                    Follow up mode: Calling
                  </p>
                  <p className="text-[14px] text-[#828282] mt-4">
                    Rahul Shah : H&M
                  </p>
                </div>
                <div>
                  <img src={call_icon} alt="call" />
                </div>
              </div>
              <hr />
              <div className="flex justify-between items-center pt-4">
                <div className="flex items-center ">
                  <div>
                    <img src={white_calender_icon} alt="calender" />
                  </div>
                  <p className="text-[14px] text-[#7B7B7B] ml-1">
                    Mon, 10 July 2022
                  </p>
                </div>
                <Link to="/tasks/customer-history" className="w-6 mr-2">
                  <img src={avatar} className="rounded-full" alt="avatar" />
                </Link>
              </div>
            </div>

            {/* Edit Tasks */}
            {editTask ? (
              <div>
                <div>
                  <EditTaskModal
                    closeModal={closeModal}
                    setSuccessModal={setSuccessModal}
                  />
                </div>
              </div>
            ) : null}

            {successModal ? (
              <EmailTaskSuccessModal setSuccessModal={setSuccessModal} />
            ) : null}

            {/* Create New Task */}
            <div className="border mt-4 text-center p-2 text-[14px] border-[#2F80ED] rounded-lg w-[95%]">
              <Link to="/tasks/create-task">
                <button className="text-[#2F80ED] font-bold">
                  Create New Task
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className={`${tasksFilter ? "w-[14rem]" : ""} mt-6`}>
          <div className="flex justify-end w-full">
            <div className="w-full flex justify-end">
              <img
                src={bi_filter_yellow}
                alt="filters"
                className="cursor-pointer w-10 shadow-lg"
                onClick={toggleTasksFilter}
              />
            </div>
          </div>
          {tasksFilter ? (
            <div className="w-full exhibition-filter">
              <TaskFilter />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default TodayTasks;
